import { useState } from 'react';
import { observer } from 'mobx-react';
import { redirectToOnboardingIntroduction } from '$src/utils/redirect';
import useStores from '$src/hooks/useStores';
import useLocationContext from '$src/hooks/useLocationContext';
import OnboardingContainer from '$src/components/OnboardingContainer';
import { handleBackToRingDashboard } from '$src/utils/handleBack';
import AlertsPreferencesTable, { mergePreferences, usePreferences } from '$src/components/AlertsPreferencesTable';
import alertPreferencesImage from '$src/assets/img/onboardingAlertPreferences.png';
import { ChimeAlertsIcon } from '@ring-icons';

function AlertPreferences() {
  const locationId = useLocationContext();
  const {
    sessionStore: { isMobile, user },
    preferencesStore: { putPreferences, contacts, alertPreferences, preferences },
  } = useStores();
  const [fetchingPreferences, setFetchingPreferences] = useState(true);
  const [localPreferences, setLocalPreferences] = useState(alertPreferences);
  const [puttingPreferences, setPuttingPreferences] = useState(false);
  const [alert, setAlert] = useState(null);

  usePreferences(user.user_id, locationId, setFetchingPreferences);

  const handlePreferences = (key, value, checked) => {
    const newPreferences = mergePreferences({ preferences: localPreferences, key, value, checked });
    setLocalPreferences(newPreferences);
  };

  const onPrimaryActionHandler = async () => {
    setPuttingPreferences(true);
    try {
      await putPreferences({ ...preferences, ...localPreferences }, user.user_id, locationId);
      redirectToOnboardingIntroduction(locationId);
    } catch (e) {
      setAlert({ type: 'error', message: 'There was an error saving changes, please try again.' });
    } finally {
      setPuttingPreferences(false);
    }
  };

  return (
    <OnboardingContainer
      headerTitle="Set Up Security Alerts"
      icon={ChimeAlertsIcon}
      title="Alert Preferences"
      subtitle="Select who should receive alerts for each event category. Emergency Alerts will always result in a text message and phone call to your emergency contacts."
      primaryText="Continue"
      image={alertPreferencesImage}
      alert={alert}
      handleClose={() => handleBackToRingDashboard(isMobile)}
      handleBack={() => redirectToOnboardingIntroduction(locationId)}
      primaryActionHandler={onPrimaryActionHandler}
      data-testid="alert-preferences"
      warningOnClose
      loading={puttingPreferences}
    >
      <AlertsPreferencesTable
        updatePreferences={handlePreferences}
        loading={fetchingPreferences}
        user={user}
        contacts={contacts}
        alertPreferences={localPreferences}
      />
    </OnboardingContainer>
  );
}

export default observer(AlertPreferences);
